var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZplFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    fill: "#0B2133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19",
    fill: "#596C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0091 15.4066V16H7.20828V15.4066H10.0091ZM9.95706 12.4423L7.51797 16H7V15.5467L9.45006 12H9.95706V12.4423ZM9.68849 12V12.5962H7.00822V12H9.68849Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2522 14.5412H11.2245V13.9478H12.2522C12.4203 13.9478 12.5564 13.9203 12.6606 13.8654C12.7665 13.8086 12.8442 13.7317 12.8935 13.6346C12.9429 13.5357 12.9675 13.4231 12.9675 13.2967C12.9675 13.174 12.9429 13.0595 12.8935 12.9533C12.8442 12.8471 12.7665 12.761 12.6606 12.6951C12.5564 12.6291 12.4203 12.5962 12.2522 12.5962H11.4712V16H10.7175V12H12.2522C12.5628 12 12.8278 12.0559 13.047 12.1676C13.2681 12.2775 13.4362 12.4304 13.5513 12.6264C13.6682 12.8205 13.7267 13.0421 13.7267 13.2912C13.7267 13.5495 13.6682 13.772 13.5513 13.9588C13.4362 14.1456 13.2681 14.2894 13.047 14.3901C12.8278 14.4908 12.5628 14.5412 12.2522 14.5412Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7787 15.4066V16H14.7726V15.4066H16.7787ZM15.0001 12V16H14.2464V12H15.0001Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZplFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "zpl-file.5e6bd74b45bfe164b6a65bb1fb97817b.svg";